"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultController = void 0;
const messaging_common_1 = require("@guided-methods/messaging-common");
const streaming_1 = require("@guided-methods/streaming");
const regexp = /guide\/Fe\/(.*)\/chunk\/(.*)\/(.*)/;
const defaultController = (gatewayUrl, http, logger, rootChannelId, streamingService) => {
    const messaging = (0, messaging_common_1.useMessagingOverHttp)(gatewayUrl)({ http, logger });
    return async (message) => {
        message.context = { ...message.context, rootChannelId };
        if ((message.to === streaming_1.createStreamingChannelV2.id || message.to === streaming_1.createStreamingChannel.id) &&
            message.type === messaging_common_1.GuideMessageType.Data) {
            try {
                const streamId = await streamingService.createStream(message);
                const data = message.to === streaming_1.createStreamingChannelV2.id
                    ? {
                        type: streaming_1.StreamingServiceResponseType.Ok,
                        measurementId: streamId,
                        timeStarted: new Date(Date.now()).toDateString(),
                        status: 'Started',
                        signals: message.data.measurements,
                    }
                    : {
                        type: streaming_1.StreamingServiceResponseType.Ok,
                        measurementId: streamId,
                        timeStarted: new Date(Date.now()).toDateString(),
                        status: 'Started',
                    };
                const response = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data,
                };
                return await messaging.messageService.forward(response);
            }
            catch (error) {
                logger.error({ message: `Error when creating stream: ${error?.message}`, ...message.context });
                const errorResponse = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: {
                        type: streaming_1.StreamingServiceResponseType.Error,
                        error: 500,
                        errorMessage: error?.message ?? 'Failed to create stream'
                    },
                };
                return await messaging.messageService.forward(errorResponse);
            }
        }
        if (message.to === streaming_1.startStreamingChannel.id && message.type === messaging_common_1.GuideMessageType.Data) {
            try {
                streamingService.startStream(message);
            }
            catch (error) {
                logger.error({ message: `Error when starting stream: ${error?.message}`, ...message.context });
                const errorResponse = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: {
                        type: streaming_1.StreamingServiceResponseType.Error,
                        error: 500,
                        errorMessage: error?.message ?? 'Failed to start stream'
                    },
                };
                return await messaging.messageService.forward(errorResponse);
            }
        }
        if (message.to === streaming_1.stopStreamingChannel.id && message.type === messaging_common_1.GuideMessageType.Data) {
            try {
                await streamingService.stopStream(message);
                const response = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: { type: streaming_1.StreamingServiceResponseType.Ok },
                };
                return await messaging.messageService.forward(response);
            }
            catch (error) {
                logger.error({ message: `Error when stopping stream: ${error?.message}`, ...message.context });
                const errorResponse = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: {
                        type: streaming_1.StreamingServiceResponseType.Error,
                        error: 500,
                        errorMessage: error?.message ?? 'Failed to stop stream'
                    },
                };
                return await messaging.messageService.forward(errorResponse);
            }
        }
        if (message.to === streaming_1.destroyStreamingChannel.id && message.type === messaging_common_1.GuideMessageType.Data) {
            try {
                await streamingService.destroyStream(message);
                const response = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: { type: streaming_1.StreamingServiceResponseType.Ok },
                };
                return await messaging.messageService.forward(response);
            }
            catch (error) {
                logger.error({ message: `Error when destroying stream: ${error?.message}`, ...message.context });
                const errorResponse = {
                    to: message.data.responseChannel,
                    type: messaging_common_1.GuideMessageType.Data,
                    context: message.context,
                    data: {
                        type: streaming_1.StreamingServiceResponseType.Error,
                        error: 500,
                        errorMessage: error?.message ?? 'Failed to destroy stream'
                    },
                };
                return await messaging.messageService.forward(errorResponse);
            }
        }
        if (!message.to.startsWith(rootChannelId)) {
            logger.debug({
                message: `Sending message outside: ${JSON.stringify(message)}`,
                ...message.context,
            });
            return await messaging.messageService.forward(message);
        }
    };
};
exports.defaultController = defaultController;
